import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Router } from "@angular/router";
import {OrderService} from "../../../service/order.service";
import {ConfirmationDialogComponent} from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {SnackbarService} from "../../../service/snackbar.service";
import {Order} from "../../../model/order";

interface config {
  name: string,
  route: string,
  icon: string,
  orderId: string,
}
@Component({
  selector: 'app-order-menu',
  templateUrl: './order-menu.component.html',
  styleUrls: ['./order-menu.component.css']
})
export class OrderMenuComponent implements OnInit {
  @Input() navigationEntries: config[];
  @Input() order: Order;
  @Input() cancelStatisticRequests: () => void;
  @Output() archiveResponse: EventEmitter<Order> = new EventEmitter<Order>();
  showSpinner: boolean = false;

  constructor(private router: Router, private orderService: OrderService, private dialog: MatDialog,
              private snackBarService: SnackbarService) { }

  ngOnInit(): void {
  }

  navigate(route: string) {
    this.cancelStatisticRequests();
    this.router.navigate([route]);
  }

  openPermissions() {
    this.cancelStatisticRequests();
    this.router.navigate(['/order_permissions']);
  }

  openUserGroupManagement() {
    this.cancelStatisticRequests();
    this.router.navigate(['/user_group_management']);
  }

  /**
   * Prompts the user with a confirmation modal to archive/restore the selected order
   * If the user confirms the prompt, the order archived flag will be set/unset
   */
  async archiveOrder(): Promise<void> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: 'auto',
      data: {
        title: this.order.archived ? 'Bestellung Wiederherstellen?' : 'Bestellung archivieren?',
        content: `Sind Sie sicher, dass die Bestellung ${this.order.orderid} ${this.order.archived ? 'wiederhergestellt' : 'archiviert'} werden soll?`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.showSpinner = true;
        this.orderService.setOrderArchivedFlag(this.order.orderid, !this.order.archived).subscribe(res => {
          this.order.archived = res;
          this.showSpinner = false;
          this.archiveResponse.emit(this.order);
          this.snackBarService.showSnackbar(`Bestellung ${res ? 'archiviert' : 'wiederhergestellt'}`, true);
        }, error => () => {
          this.snackBarService.showSnackbar(`Fehler beim ${this.order.archived ? 'Wiederherstellen' : 'Archivieren'}`, false);
        });
      }
    });
  }
}
